import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, InputAdornment } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ToasterBox from '../../singleComponents/toaster/ToasterBox';
import GlobalContext from '../../../../context/GlobalContext';
import { TourContext } from '../../../../context/tour';
import LoginAPI from '../../../../services/API/others/LoginAPI';
import { verifyEmail } from '../../../../services/auxiliaryFunctions/functions';
import tourInitialState from '../../../../services/driverJS/tourInitialState';
import { retrieveUserData } from '../../../../services/routerPagesManager/routerPagesManager';
import {
  ButtonStyled,
  ButtonTextStyled,
  Link2Styled,
  LinkTwoStyled,
} from '../../../pages/others/login/login.styles';
import {
  Container,
  FooterTextStyled,
  FormsAndHelperSectionContainerStyled,
  FormsSectionStyled,
  HelpersSectionStyled,
  LoginTitleStyled,
  OutlinedInputStyled,
} from './loginSection.styles';

const errorMessage =
  'E-mail/senha incorreto(s). Para alterar acesse "Recuperar conta" ou tente novamente';

export default function LoginSection(props) {
  const { setIsAccountRetrieve } = props;
  const { setUserData } = useContext(GlobalContext);
  const { setDialogOpen, setTourCompletion } = useContext(TourContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorSubmit, setErrorSubmit] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [toasterMsg, setToasterMsg] = useState('');
  const navigate = useNavigate();

  const handleSubmitLogin = () => {
    const submit = () => {
      if (verifyEmail(email)) {
        const auth = { email, password };
        let redirectPath = '/login';
        LoginAPI.postLogin({ auth })
          .then((response) => {
            if (response.data.messages) {
              // TODO: confirmar como é o retorno de erro
              setToasterMsg(response.data.messages);
            } else {
              const token = response?.data;
              const { user } = retrieveUserData(token);
              redirectPath = user.user_type;
              localStorage.setItem('token', JSON.stringify(token));
              localStorage.setItem('user', JSON.stringify(user));
              if (!token.tour_status) {
                setTourCompletion(tourInitialState);
                setDialogOpen(true);
              } else {
                setTourCompletion(token.tour_status);
              }
              setUserData(user);
              navigate(`/${redirectPath}`);
            }
          })
          .catch((error) => {
            console.log(error);
            setToasterMsg(error.response.data.messages);
          })
          .finally(() => {
            setTimeout(() => setToasterMsg(''), 3000);
          });
      } else {
        setToasterMsg(errorMessage);
      }
    };

    if (LoginAPI.verifyDomain()) {
      submit();
    }
  };

  return (
    <Container>
      {toasterMsg && <ToasterBox message={toasterMsg} />}
      <FormsAndHelperSectionContainerStyled>
        <FormsSectionStyled>
          <LoginTitleStyled variant="h1">Login</LoginTitleStyled>
          <OutlinedInputStyled
            fullWidth
            placeholder="E-mail"
            value={email}
            error={errorSubmit}
            onChange={({ target }) => {
              setErrorSubmit(false);
              setEmail(target.value.trim());
            }}
          />
          <OutlinedInputStyled
            fullWidth
            placeholder="Senha"
            type={showPassword ? 'text' : 'password'}
            value={password}
            error={errorSubmit}
            onChange={({ target }) => {
              setErrorSubmit(false);
              setPassword(target.value);
            }}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
          <ButtonStyled
            fullWidth
            onClick={handleSubmitLogin}
            disabled={!email || !password}
          >
            <ButtonTextStyled variant="h3">Entrar</ButtonTextStyled>
          </ButtonStyled>
        </FormsSectionStyled>
        <HelpersSectionStyled>
          <Link2Styled
            onClick={() => setIsAccountRetrieve(true)}
            variant="caption"
            style={{ fontSize: '14px' }}
          >
            Recuperar senha
          </Link2Styled>
        </HelpersSectionStyled>
      </FormsAndHelperSectionContainerStyled>

      <FooterTextStyled variant="caption">
        <LinkTwoStyled to="/">Termos de uso</LinkTwoStyled>
        {' e '}
        <LinkTwoStyled to="/">Política de Privacidade</LinkTwoStyled>
      </FooterTextStyled>
    </Container>
  );
}

LoginSection.propTypes = {
  setIsAccountRetrieve: PropTypes.func.isRequired,
};
